import React from 'react';
import CallRecordItemV2 from 'flow/components/call-history-v2/CallRecordItemV2';
import { DateGroupedRowProps } from 'flow/components/call-history-v2/DateGroupedList';
import ListRowFrame from 'flow/components/nav/list-keys/ListRowFrame';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectCallRecordQueueKey } from 'flow/selectors/call-records-selectors';
import { CallRecordKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';
import { generatePath } from 'flow/utils/router-utils';

interface Props extends DateGroupedRowProps {
    callRecordKey: CallRecordKey;
}

const MissedQueueCallItem = ({
    callRecordKey,
    index,
    tabStopStore,
    tabStopKey,
    onUnmountWithFocus,
}: Props) => {
    const queueKey = useAppSelector((state) =>
        selectCallRecordQueueKey(state, callRecordKey),
    );

    return (
        <ListRowFrame
            index={index}
            isFocusable={true}
            tabStopStore={tabStopStore}
            tabStopKey={tabStopKey}
            onUnmountWithFocus={onUnmountWithFocus}
        >
            {/* The link opens the call in its queue's history, as a row of
                that history does. */}
            <CallRecordItemV2
                callRecordKey={callRecordKey}
                queueKey={queueKey}
                showMarkIsHandledIfMissed={true}
                showQueueName={true}
                highlightOnCard={true}
                segmentContext="Missed queue calls widget"
                pageType="pbx"
                linkTo={
                    queueKey
                        ? generatePath(
                              routes['pbx.queues.queueKey.callRecordKey'],
                              { queueKey, callRecordKey },
                          )
                        : undefined
                }
            />
        </ListRowFrame>
    );
};

export default React.memo(MissedQueueCallItem);
